module.exports = __webpack_public_path__ + "static/assets/24ee36fed99a13e5b019085b51933a2c.png";